module.exports = __webpack_public_path__ + "static/media/icon_trande_exchange.d8d66209.svg";